import axios from 'axios';
import jsonp from 'jsonp';

import Config, { getCommParams, getCommUserParams } from './config.js';
/*eslint-disable*/
/** 获取短信验证码接口 */
export async function getMobileCode(params) {
  return axios({
    url: `${Config.API_ROOT}/mine/v1/getMobileCode`,
    method: 'get',
    params: Object.assign(params, getCommParams()),
  });
}

export async function getUserInfo(params) {
  return axios({
    url: `${Config.API_ROOT}/mine/v1/userInfo`,
    method: 'get',
    params: Object.assign(params, getCommUserParams()),
  });
}

/** 获取短信验证码接口 拼图校验 */
export async function getMobileCodeV2(params) {
  return axios({
    url: `${Config.API_ROOT}/mine/v2/getMobileCode`,
    method: 'get',
    params: Object.assign(params, getCommParams()),
  });
}

/** 创建拼图 */
export async function captchaCreate(params) {
  return axios({
    url: `//risk.bz.mgtv.com/captcha/risk-captcha/enc/create?platform=pcweb&did=${params.did}`,
    method: 'post',
    data: Object.assign(params, getCommParams()),
  });
}

/** 校验拼图 */
export async function captchaCheck(params) {
  return axios({
    url: `//risk.bz.mgtv.com/captcha/risk-captcha/enc/check?platform=pcweb&did=${params.did}`,
    method: 'post',
    data: Object.assign(params, getCommParams()),
  });
}

/** 短信验证码登录接口 */
export async function mobileCodeLogin(params) {
  return axios({
    url: `${Config.API_ROOT}/mine/v1/mobileCodeLogin?platform=pcweb`,
    method: 'post',
    data: Object.assign(params, getCommParams()),
  });
}

/** 退出登录 */
export async function logout() {
  let { token, uid } = JSON.parse(localStorage.getItem('sh-userInfo'));
  return axios({
    url: `${Config.API_ROOT}/mine/v1/logout?platform=pcweb&token=${token}&uid=${uid}`,
    method: 'POST',
    withCredentials: true,
  });
}

/** 上传视频获取签名token */
export async function uploadGetStsToken(params) {
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/video/genStsToken`,
    method: 'get',
    params: Object.assign(params, getCommUserParams()),
  });
}

/** 获取文件正式地址 */
export async function getFileSourceUrl(params) {
  return axios({
    url: `${Config.UPLOAD_ROOT}/download/getUrlById`,
    method: 'get',
    params: Object.assign(params, getCommUserParams()),
  });
}

/** 视频封面 */
export async function getVideoCover(params) {
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/video/snapshotRc`,
    method: 'get',
    params: Object.assign(params, getCommUserParams()),
  });
}

/** 上传图片获取签名token */
export async function getFileUploadToken(params) {
  let { token, uid } = JSON.parse(localStorage.getItem('sh-userInfo'));
  return axios({
    url: `${Config.API_ROOT}/upload/v1/getUploadToken?platform=pcweb&token=${token}&uid=${uid}`,
    method: 'POST',
    data: Object.assign(params, getCommParams()),
  });
}

/** 发布帖子/视频 */
export async function publish(params) {
  let { token, uid } = JSON.parse(localStorage.getItem('sh-userInfo'));
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/publish?token=${token}&uid=${uid}`,
    method: 'POST',
    data: Object.assign(params, getCommParams()),
  });
}

/** 获取视频列表 */
export async function getVideoList(params) {
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/myPCList`,
    method: 'get',
    params: Object.assign(params, getCommUserParams()),
  });
}

/** 删除帖子 */
export async function deleteVideo(params) {
  let { token, uid } = JSON.parse(localStorage.getItem('sh-userInfo'));
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/delete?token=${token}&uid=${uid}`,
    method: 'POST',
    data: Object.assign(params, getCommParams()),
  });
}

/** 删除草稿 */
export async function deleteDraft(params) {
  let { token, uid } = JSON.parse(localStorage.getItem('sh-userInfo'));
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/draft/delete?token=${token}&uid=${uid}`,
    method: 'POST',
    data: Object.assign(params, getCommParams()),
  });
}

/** 我的草稿列表 */
export async function getMyDraftList(params) {
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/myDraft`,
    method: 'get',
    params: Object.assign(params, getCommUserParams()),
  });
}

/** 导出我的草稿 */
export async function exportDraftExcel(params) {
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/draft/export`,
    method: 'get',
    params: Object.assign(params, getCommUserParams()),
    responseType: 'blob',
  });
}

/** 用导出的 excel 回写草稿 */
export async function importDraftExcel(file) {
  const form = new FormData();
  form.append('file', file);
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/draft/import`,
    method: 'post',
    params: getCommUserParams(),
    data: form,
  });
}

/** 帖子是否设私更新 */
export async function setPrivate(params) {
  let { token, uid } = JSON.parse(localStorage.getItem('sh-userInfo'));
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/isPrivate/update?token=${token}&uid=${uid}`,
    method: 'POST',
    data: Object.assign(params, getCommParams()),
  });
}

/** 作品详情 */
export async function getVideoDetail(params) {
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/myVideoFeed`,
    method: 'get',
    params: Object.assign(params, getCommUserParams()),
  });
}

/** 编辑草稿 */
export async function editDraft(params) {
  let { token, uid } = JSON.parse(localStorage.getItem('sh-userInfo'));
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/draft/edit?token=${token}&uid=${uid}`,
    method: 'POST',
    data: Object.assign(params, getCommParams()),
  });
}

/** 保存草稿 */
export async function saveDraft(params) {
  let { token, uid } = JSON.parse(localStorage.getItem('sh-userInfo'));
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/draft/store?token=${token}&uid=${uid}`,
    method: 'POST',
    data: Object.assign(params, getCommParams()),
  });
}

/** 草稿详情 */
export async function getDraftDetail(params) {
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/draft/detail`,
    method: 'get',
    params: Object.assign(params, getCommUserParams()),
  });
}

/** 帖子详情 */
export async function getFeedDetail(params) {
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/edit/echo`,
    method: 'get',
    params: Object.assign(params, getCommUserParams()),
  });
}

/** 发布草稿 */
export async function publishDraft(params) {
  let { token, uid } = JSON.parse(localStorage.getItem('sh-userInfo'));
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/draft/publish?token=${token}&uid=${uid}`,
    method: 'POST',
    data: Object.assign(params, getCommUserParams()),
  });
}

/** 社区活动列表 */
export async function getActivityList(params) {
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/activity/list?onlineStatus=1`,
    method: 'get',
    params: Object.assign(params, getCommUserParams()),
  });
}

/** 文物列表 */
export async function getCollectList(params) {
  return axios({
    url: `${Config.API_ROOT}/search/v3/collect`,
    method: 'get',
    params: Object.assign(params, getCommUserParams()),
  });
}

/** 编辑帖子/视频 */
export async function editFeed(params) {
  let { token, uid } = JSON.parse(localStorage.getItem('sh-userInfo'));
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/edit?token=${token}&uid=${uid}`,
    method: 'POST',
    data: Object.assign(params, getCommParams()),
  });
}

/** 获取banner底图配置 */
export async function getBanner(params) {
  // 线上130  测试210
  return axios({
    url: `${Config.API_ROOT}/homepage/v1/channelModule?pageCode=webCreators&channelId=130`,
    method: 'get',
    params: Object.assign(params, getCommParams()),
  });
}

/** 发帖推荐话题列表 */
export async function getTopicList(params) {
  return axios({
    url: `${Config.COMMUNITY_ROOT}/ugc/v1/feed/topic/recommendList`,
    method: 'get',
    params: Object.assign(params, getCommParams()),
  });
}

// 获取视频地址
export async function getVideoSource(params) {
  // 拼接参数
  const baseUrl = '//szwb-stream.api.mgtv.com/v1/museum/source';
  const query = Object.entries({
    ...getCommUserParams(),
    ...params,
  })
    .map(
      ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
    )
    .join('&');
  const url = `${baseUrl}?${query}`;

  return new Promise((resolve, reject) => {
    jsonp(url, { name: 'callback', timeout: 10000 }, (err, data) => {
      if (err) {
        reject(err);
      } else {
        resolve({ data });
      }
    });
  });
}

// 获取标签类型
export async function getTagType(params) {
  return axios({
    url: `${Config.API_ROOT}/contentTag/v1/types`,
    method: 'get',
    params: Object.assign(params, getCommParams()),
  });
}

// 内容标签中指定类型的相关标签
export async function getTagList(params) {
  return axios({
    url: `${Config.API_ROOT}/contentTag/v1/tags`,
    method: 'get',
    params: Object.assign(params, getCommParams()),
  });
}
